import { Link } from 'react-router-dom';
import { X, GitCompare, Trash2 } from 'lucide-react';
import { Button } from './ui/button';

const CompareBar = ({ selectedSpas, onRemove, onClear }) => {
  if (selectedSpas.length === 0) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-slate-900 text-white p-4 z-50 shadow-lg border-t border-slate-700"
      data-testid="compare-bar"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <GitCompare className="w-5 h-5 text-blue-400" />
          <span className="font-medium">
            {selectedSpas.length} spa{selectedSpas.length > 1 ? 's' : ''} sélectionné{selectedSpas.length > 1 ? 's' : ''}
          </span>
          <span className="text-slate-400 text-sm">(max 3)</span>
        </div>

        <div className="flex items-center gap-3 flex-1 justify-center overflow-x-auto">
          {selectedSpas.map((spa) => (
            <div 
              key={spa.slug}
              className="flex items-center gap-2 bg-slate-800 rounded-lg px-3 py-2 min-w-fit"
            >
              <img 
                src={spa.images?.[0] || 'https://images.unsplash.com/photo-1574186907057-849802af13d9?w=100'} 
                alt={spa.name}
                className="w-10 h-10 rounded object-cover"
              />
              <div className="hidden sm:block">
                <div className="text-sm font-medium line-clamp-1 max-w-[120px]">{spa.name}</div>
                <div className="text-xs text-slate-400">{spa.places} places</div>
              </div>
              <button
                onClick={() => onRemove(spa.slug)}
                className="p-1 hover:bg-slate-700 rounded transition-colors"
                aria-label={`Retirer ${spa.name} de la comparaison`}
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={onClear}
            className="text-slate-400 hover:text-white hover:bg-slate-800"
          >
            <Trash2 className="w-4 h-4 mr-1" />
            <span className="hidden sm:inline">Effacer</span>
          </Button>
          
          {selectedSpas.length >= 2 && (
            <Link to={`/comparer?spas=${selectedSpas.map(s => s.slug).join(',')}`}>
              <Button className="bg-orange-500 hover:bg-orange-600" data-testid="compare-button">
                <GitCompare className="w-4 h-4 mr-2" />
                Comparer
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompareBar;
